/** How long the browser has to start reading the file before its address is released. */
const REVOKE_AFTER_MS = 1000

/**
 * Hands a fetched file to the browser as a download. The link is in the
 * document while it is clicked and the address is released a moment later, not
 * at once: Safari and older browsers abandon a download whose link is detached
 * or whose object URL is revoked before they have started on it.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.hidden = true
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS)
}
